import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=496fb061"
import script from "./Performance.vue?vue&type=script&lang=ts"
export * from "./Performance.vue?vue&type=script&lang=ts"
import style0 from "./Performance.vue?vue&type=style&index=0&id=496fb061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports